import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import './styles/responsive.css';

import PillNav from './components/PillNav';
import Home from './pages/Home';
import About from './pages/About';
import DepartmentPage from './pages/DepartmentPage';
import DoctorsPage from './pages/DoctorsPage';
import PatientsPage from './pages/PatientsPage';
import AppointmentPage from './pages/AppointmentPage';
import BlogPage from './pages/BlogPage';
import BlogDetailPage from './pages/BlogDetailPage';
import ContactPage from './pages/ContactPage';
import Insurance from './pages/Insurance';
import FAQPage from './pages/FAQPage';
import WhatsAppFloat from "./components/WhatsAppFloat";
import Footer from './components/Footer';

// Admin imports
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';

function AppContent() {
  const location = useLocation();

  useEffect(() => {
    const titles = {
      '/': 'Swarup Hospital',
      '/about': 'About Us | Swarup Hospital',
      '/services': 'Services & Specialties | Swarup Hospital',
      '/doctors': 'Find a Doctor | Swarup Hospital',
      '/patients': 'Patients & Visitors | Swarup Hospital',
      '/appointments': 'Appointments | Swarup Hospital',
      '/blog': 'Health Blog & Resources | Swarup Hospital',
      '/blog/:blogId': 'Article | Swarup Hospital',
      '/contact': 'Locations & Contact | Swarup Hospital',
      '/insurance': 'Insurance & Mediclaim | Swarup Hospital',
      '/faq': 'Frequently Asked Questions | Swarup Hospital',
      '/admin/login': 'Admin Login | Swarup Hospital',
      '/admin': 'Admin Dashboard | Swarup Hospital',
      '/admin/dashboard': 'Admin Dashboard | Swarup Hospital',
    };

    document.title = titles[location.pathname] || 'Swarup Hospital';
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [location]);

  const isAdminRoute = location.pathname.startsWith('/admin');

  return (
    <div className="App">
      {!isAdminRoute && (
        <div style={{ position: 'absolute', width: '100%', top: 0, zIndex: 100 }}>
          <PillNav
            logo="/assets/images/Swarup Logo (1).png"
            logoAlt="Swarup Hospital"
            items={[
              { label: 'Home', href: '/' },
              { label: 'About', href: '/about' },
              { label: 'Services', href: '/services' },
              { label: 'Doctors', href: '/doctors' },
              { label: 'Patients', href: '/patients' },
              { label: 'Blog', href: '/blog' },
              { label: 'Insurance', href: '/insurance' },
              { label: 'Contact', href: '/contact' },
              { label: 'Appointments', href: '/appointments' }
            ]}
            activeHref={location.pathname}
            className="custom-nav"
            baseColor="#000000"
            pillColor="rgba(0, 0, 0, 0.5)"
            activePillColor="#000000"
            hoveredPillTextColor="#ffffff"
            pillTextColor="#ffffff"
          />
        </div>
      )}
      <main className={isAdminRoute ? "" : "App-main"}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<DepartmentPage />} />
          <Route path="/doctors" element={<DoctorsPage />} />
          <Route path="/patients" element={<PatientsPage />} />
          <Route path="/appointments" element={<AppointmentPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:blogId" element={<BlogDetailPage />} />
          <Route path="/insurance" element={<Insurance />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
        </Routes>
      </main>
      <WhatsAppFloat />
      {!isAdminRoute && <Footer />}
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
